import { RouterProvider } from 'react-router-dom';

import { Providers } from '@/app/providers';
import { router } from '@/app/router';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';

/**
 * The application.
 *
 * The error boundary sits outside the router, so a render error in one screen shows a
 * panel rather than a blank page, and the rest of the application keeps working.
 */
export default function App() {
  return (
    <ErrorBoundary>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </ErrorBoundary>
  );
}
